import styles from './NonWholesaleStateWarningPopUp.module.css';
import PopUp from '../PopUp/PopUp';

const NonWholesaleStateWarningPopUp = ({ isOpen, stateName, onConfirm, onCancel }) => {
    return (
        isOpen && (
            <PopUp
                maxWidth={600}
                close={onCancel}
                closeButton={false}
                closeWithBackground={false}
            >
                {({ closeAnimation }) => (
                    <div className={styles.content}>
                        <div className={styles.textContainer}>
                            <span className={styles.title}>Pricing Update</span>
                            <span className={styles.description}>
                                Switch & Save pricing is not available in <strong>{stateName}</strong>.
                                If you continue, standard retail pricing will apply and your plan will be updated automatically.
                            </span>
                        </div>
                        <div className={styles.optionsContainer}>
                            <button onClick={onConfirm} className={styles.proceedButton}>
                                Continue with updated pricing
                            </button>
                            <span onClick={closeAnimation} className={styles.cancelText}>
                                Go back and correct my state
                            </span>
                        </div>
                    </div>
                )}
            </PopUp>
        )
    );
};

export default NonWholesaleStateWarningPopUp;
